import React from 'react';
import { observer } from 'mobx-react-lite';

export const BetTypes = observer(
  ({ handleChangeBetType, odd, betTypesActiveBets, betTypes, isMobile }) => {
    return (
      <div className={isMobile ? 'mob-g-area-btn-bl' : 'g-area-btn-block'}>
        {betTypes.map((betType) => (
          <div
            key={betType.name}
            className={`${isMobile ? 'mob-g-area-btn-item' : 'g-area-btn-item'} ${
              odd === +betType.odd ? 'active' : ''
            }`}
            onClick={() => handleChangeBetType(+betType.odd, betType.color)}
          >
            <div
              className={`${
                isMobile ? 'mob-g-btn-ins-t' : 'g-btn-ins-t'
              } ${betType.name.toLowerCase()}`}
            >
              <span className={isMobile ? 'mob-g-btn-ins-t-sp' : 'g-btn-ins-t-sp'}>
                x{betType.odd}
              </span>
            </div>
            <div className={isMobile ? 'mob-g-btn-ins-b' : 'g-btn-ins-b'}>
              <span className={isMobile ? 'mob-g-btn-ins-b-c-l' : 'g-btn-ins-b-c-l'}>
                {/* <i className='bc-i-bet-type-user' /> */}
                <i className='ui-lib-contact' />
              </span>
              <p className={isMobile ? 'mob-g-btn-ins-b-c-r' : 'g-btn-ins-b-c-r'}>
                {betTypesActiveBets[betType.color]}
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  }
);
